exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-circle-custom {\n\tborder-radius: 50%;\n\twidth: 25px;\n\theight: 25px;\n}\n.not-img {\n\tdisplay: inline-block;\n\tborder-radius: 50%;\n\twidth: 25px;\n\theight: 25px;\n\tfont-weight: bolder;\n\tcolor: white;\n\ttext-align: center;\n\tpadding-top: 3px;\n}\n.transition-img-circle-custom {\n\ttransition: margin-left 0.5s;\n}\n.popper {\n\tborder-radius: 5px;\n\tpadding: 0 3px;\n\ttext-align: left !important;\n\tfont-size: 10px !important;\n\tmin-width: 75px !important;\n\theight: auto !important;\n}\n", ""]);

// exports
